import { ThoughtspotIntegrationService } from '@mode/shared/util-thoughtspot-integrated';
import { Component, EventEmitter, Input, Output, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { trackByFactory } from '@mode/capra';

@Component({
  selector: 'mode-axis-fit-button',
  templateUrl: './axis-fit.component.html',
  styleUrls: ['./axis-fit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AxisFitComponent implements OnChanges {
  @Input() disabled = false;
  @Input() compact = false;

  @Output()
  compactChange = new EventEmitter<boolean>();
  readonly isAnalystStudio = this.thoughtspotIntegrationService.currOrgIntegrated();

  fitTypeItems = [
    { value: 'FitToWidth', label: 'Fit to screen' },
    { value: 'FitToContent', label: 'Fit to data' },
  ];

  selected = this.fitTypeItems[1];

  trackByValue = trackByFactory<{ value: string }>(({ value }) => value);
  isOpen = false;

  ngOnChanges() {
    this.selected = this.compact ? this.fitTypeItems[0] : this.fitTypeItems[1];
  }

  setFitType(item: { value: string }) {
    this.compactChange.emit(item.value === this.fitTypeItems[0].value);
  }
  constructor(private thoughtspotIntegrationService: ThoughtspotIntegrationService) {}
}
